
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { EcommerceSettings } from '@/components/admin/campaigns/types';

interface EcommerceWidgetTabProps {
  settings: EcommerceSettings;
  updateSettings: (settings: Partial<EcommerceSettings>) => void;
}

const EcommerceWidgetTab: React.FC<EcommerceWidgetTabProps> = ({
  settings,
  updateSettings,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Widget Configuration</CardTitle>
        <CardDescription>
          Customize how the referral widget appears on your store
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-3">
          <Label>Widget Placement</Label>
          <RadioGroup 
            value={settings.widgetPlacement} 
            onValueChange={(value) => updateSettings({ 
              widgetPlacement: value as EcommerceSettings['widgetPlacement'] 
            })}
            className="flex flex-col space-y-2"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="product_page" id="product_page" />
              <Label htmlFor="product_page" className="cursor-pointer">Product Pages</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="cart_page" id="cart_page" />
              <Label htmlFor="cart_page" className="cursor-pointer">Cart Page</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="checkout_page" id="checkout_page" />
              <Label htmlFor="checkout_page" className="cursor-pointer">Checkout Page</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="all" id="all_pages" />
              <Label htmlFor="all_pages" className="cursor-pointer">All Pages (Global)</Label>
            </div>
          </RadioGroup>
        </div>

        <div className="space-y-3">
          <Label>Widget Type</Label>
          <RadioGroup 
            value={settings.widgetType} 
            onValueChange={(value) => updateSettings({ 
              widgetType: value as EcommerceSettings['widgetType'] 
            })}
            className="flex flex-col space-y-2"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="popup" id="popup" />
              <Label htmlFor="popup" className="cursor-pointer">Popup</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="inline" id="inline" />
              <Label htmlFor="inline" className="cursor-pointer">Inline Widget</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="sidebar" id="sidebar" />
              <Label htmlFor="sidebar" className="cursor-pointer">Sidebar Widget</Label>
            </div>
          </RadioGroup>
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="post-purchase">Post-Purchase Invite Flow</Label>
            <p className="text-sm text-muted-foreground">
              Show referral invitation after customer completes purchase
            </p>
          </div>
          <Switch 
            id="post-purchase"
            checked={settings.postPurchaseEnabled}
            onCheckedChange={(checked) => updateSettings({ postPurchaseEnabled: checked })}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default EcommerceWidgetTab;
